import { useAuth } from "@/context/AuthContext";
import { ArrowRight, MapPin, SearchX } from "lucide-react";

const when = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "");

// One real container on no shelf: shelve it (scan the shelf) or say it can't be found.
export function ContainerRow({ c, onShelve, onMark }) {
  const { resolveName } = useAuth();
  const lost = !!c.cant_find;
  return (
    <div data-testid={`shelf-row-${c.id}`}
      className={`rounded-2xl border-2 p-3 ${lost ? "border-amber-300 bg-amber-50" : "border-[#E2E8F0] bg-white"}`}>
      <div className="flex items-center gap-3">
        <span className="rounded-lg bg-[#0F172A] text-white text-xl font-black tabular-nums px-3 py-1.5 shrink-0"
          data-testid={`shelf-row-parts-${c.id}`}>{c.parts}</span>
        <div className="min-w-0 flex-1">
          <div className="text-xl font-black font-mono truncate">{c.code}</div>
          <div className="text-sm text-slate-500 truncate"><span className="capitalize">{c.kind}</span>{c.name && c.name !== c.code ? ` · ${c.name}` : ""} · {c.parts} part{c.parts === 1 ? "" : "s"} inside</div>
        </div>
      </div>
      {lost && (
        <div className="mt-2 text-sm text-amber-900" data-testid={`shelf-row-lost-${c.id}`}>
          Can't find it, marked by {resolveName ? resolveName(c.cant_find.by) : c.cant_find.by} · {when(c.cant_find.at)}. It still counts as on no shelf.
        </div>
      )}
      <div className="mt-3 flex gap-2">
        <button type="button" data-testid={`shelf-row-shelve-${c.id}`} onClick={onShelve}
          className="h-14 flex-1 min-w-0 rounded-xl bg-[#0F172A] text-white text-lg font-black flex items-center justify-center gap-2 active:scale-[0.98] transition-transform">
          <MapPin className="w-6 h-6 shrink-0" />Shelve it
        </button>
        <button type="button" data-testid={`shelf-row-${lost ? "found" : "cant-find"}-${c.id}`} onClick={() => onMark(lost)}
          className="h-14 px-3 rounded-xl border-2 border-slate-300 text-base font-bold flex items-center gap-1 shrink-0 active:scale-[0.98] transition-transform">
          <SearchX className="w-5 h-5 shrink-0" />{lost ? "Found it" : "Can't find it"}
        </button>
      </div>
    </div>
  );
}

// One lot whose parts are not put away yet — the job is the parts, not the record.
export function LotCrateRow({ l, onOpen }) {
  return (
    <button type="button" data-testid={`shelf-lot-${l.id}`} onClick={onOpen}
      className="w-full text-left rounded-2xl border-2 border-[#E2E8F0] bg-white p-3 flex items-center gap-3 active:scale-[0.98] transition-transform">
      <span className="rounded-lg bg-slate-200 text-slate-900 text-xl font-black tabular-nums px-3 py-1.5 shrink-0">{l.parts}</span>
      <div className="min-w-0 flex-1">
        <div className="text-xl font-black font-mono truncate">{l.lot_number || l.code}</div>
        <div className="text-sm text-slate-500 truncate">{l.lot_name ? `${l.lot_name} · ` : ""}put {l.parts === 1 ? "this part" : `these ${l.parts} parts`} away</div>
      </div>
      <ArrowRight className="w-6 h-6 text-slate-300 shrink-0" />
    </button>
  );
}
